/**
 *
 * page-home.js
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Variable
	 *
	 *
	 */
	/**************************************************************
	 * global
	**************************************************************/
	// const root   = document.body.dataset.root;
	const mqUpLg = getComputedStyle(document.documentElement).getPropertyValue('--mqUp-lg');






	/**
	 *
	 *
	 * .home-kv
	 *
	 *
	 */
	/**************************************************************
	 * initKvSlider
	**************************************************************/
	const initKvSlider = (params) => {
		const header = document.querySelector('.l-header');

		new intervalChange('.home-kv__slider',{
			sliderSelector: '.home-kv__slider__content',
			autoplay      : true,
			immedStart    : true,
			// intervalSpeed : 600,
			intervalSpeed : 810,
			startDelay    : 0,
			put           : false,
			dots          : false,
			counter       : false,
			zIndex        : true,
			navigation    : false,
			addData       : false,
			onAddSlide    : function( target , slide , dotsCell ){
				const mainColor =  getComputedStyle(slide).getPropertyValue('--main-color');
				const subColor  =  getComputedStyle(slide).getPropertyValue('--sub-color');

				document.body.style.setProperty('--main-color', mainColor );
				document.body.style.setProperty('--sub-color', subColor );
			},
		});
	}
	window.addEventListener('load',initKvSlider);


	/**************************************************************
	 * intervalChange
	**************************************************************/
	new intervalChange('.home-kv__news',{
		sliderSelector: '.home-kv__news__content',
		autoplay      : true,
		immedStart    : false,
		intervalSpeed : 6000,
		startDelay    : 0,
		put           : false,
		dots          : false,
		counter       : false,
		zIndex        : false,
		navigation    : false,
		addData       : false,
	});






	/**
	 *
	 *
	 * .home-nav
	 *
	 *
	 */
	/**************************************************************
	 * scrollbar
	**************************************************************/
	new scrollbar('.home-nav',{
		scrollElement     : 'element',
		scrollArea        : '.home-nav__list',
		scrollInner       : '.home-nav__list ul',
		scrollbarContainer: null,
		reverseHorizontal : false,

		setScrollbarSize: false,
		scrollbarMove   : false,

		verticalClass     : 'js-scrollbar__vertical',
		verticalTrackClass: 'js-scrollbar__track',

		horizontalClass     : 'js-scrollbar__horizontal',
		horizontalTrackClass: 'js-scrollbar__track',

		setScrollbarSizeEvent: ['DOMContentLoaded','resize'],
		getScrollbarSizeEvent: ['DOMContentLoaded','resize'],
		setTrackSizeEvent    : ['load','resize'],
		setTrackPositionEvent: ['load','resize','scroll'],
		getScrollTopEvent    : ['load','scroll'],
	});






	/**
	 *
	 *
	 * .home-banner
	 *
	 *
	 */
	/**************************************************************
	 * Swiper
	**************************************************************/
	new intervalChange('.home-products_concept__figure',{
		sliderSelector: '.home-products_concept__figure__content',
		autoplay      : true,
		immedStart    : true,
		intervalSpeed : 290,
		// intervalSpeed : 1000,
		startDelay    : 0,
		put           : false,
		dots          : false,
		counter       : false,
		zIndex        : true,
		navigation    : false,
		addData       : false,
	});






	/**
	 *
	 *
	 * .home-banner
	 *
	 *
	 */
	/**************************************************************
	 * Swiper
	**************************************************************/
	new Swiper('.home-banner',{
		autoplay: {
			delay               : 4000,
			disableOnInteraction: false,
		},
		centeredSlides: true,
		loop          : true,
		speed         : 550,
		slidesPerView : 'auto',
		pagination: {
			el               : ".c-dots",
			type             : 'bullets',
			bulletElement    : 'button',
			clickable        : true,
			modifierClass    : '',
			bulletClass      : '-bullets',
			bulletActiveClass: 'is-active',
			clickableClass   : '-clickable',
			horizontalClass  : '-horizontal',
			verticalClass    : '-vertical',
			renderBullet: function(index, className){
				const number = index + 1;

				return '<li class="' + className + '">' +
					 '<button type="button">'+ number +'</button>' +
					'</li>';
			}
		},
	});





	/**
	 *
	 *
	 * .home-best
	 *
	 *
	 */
	/**************************************************************
	 * inifBestSwiper
	**************************************************************/
	const inifBestSwiper = () => {
		const root        = document.querySelector('.home-best__list');
		const totalSlides = root.querySelectorAll('.home-best__list .swiper-slide').length;

		// ------------------------------------
		// スマホ：Swiperを使わず「＋」ボタンで展開
		// ------------------------------------
		if (window.innerWidth < mqUpLg) {
			const moreBtn = root.querySelector('.home-best__list__more');
			if (moreBtn) {
				moreBtn.addEventListener('click', function () {
					root.classList.add('--expanded');
					moreBtn.style.display = 'none';
				});
			}
			return;
		}

		// ------------------------------------
		// PC：Swiperで従来どおりページネーション
		// ------------------------------------
		const bestSwiper = new Swiper(root, {
			loop          : false,
			speed         : 550,
			slidesPerView : 'auto',
			slidesPerGroup: 6,
			pagination: {
				el       : '.home-best__list__pagination',
				clickable: true,
				renderBullet: function (index, className) {
					const group = 6;
					const start = (index * group) + 1;
					const end   = Math.min((index + 1) * group, totalSlides);

					return '<button type="button" class="' + className + '" aria-label="' + start + '〜' + end + 'を表示">' +
						start + ' - ' + end +
					'</button>';
				},
			},
			breakpoints: {
				1024: {
					grid: {
						rows: 1,
					},
				},
			},
		});

		// ------------------------------------
		// dotクリック時
		// ------------------------------------
		const paginationEl = root.querySelector('.home-best__list__pagination');
		paginationEl.addEventListener('click', function (e) {
			const bullet = e.target.closest('.swiper-pagination-bullet');
			if (!bullet) return;
		});
	};
	inifBestSwiper();




})();
